var _path, _path2, _path3, _path4, _path5, _ellipse, _circle, _circle2, _ellipse2, _circle3, _ellipse3, _circle4, _circle5, _circle6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M542.409 429.187h-73.461c-73.027 0-132.228-59.201-132.228-132.228 0-73.028 59.201-132.229 132.228-132.229 73.028 0 132.229 59.201 132.229 132.229v22.038c0 20.285-16.445 36.73-36.73 36.73-20.286 0-36.73-16.445-36.73-36.73v-22.038c0-32.457-26.312-58.768-58.769-58.768v0c-32.456 0-58.768 26.311-58.768 58.768 0 32.456 26.312 58.768 58.768 58.768 32.457 0 58.769-26.312 58.769-58.768",
    stroke: "#666AF6",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M708.894 416.669c-27.448 6.502-56.477-16.775-56.477-16.775s15.491-33.808 42.947-40.29c27.448-6.502 56.469 16.755 56.469 16.755s-15.492 33.807-42.939 40.31z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.913 416.669c-27.447 6.502-56.477-16.775-56.477-16.775s15.492-33.808 42.948-40.29c27.447-6.502 56.468 16.755 56.468 16.755s-15.492 33.807-42.939 40.31z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M365.233 133.495c20.459-4.136 32.754-28.774 32.754-28.774S377.1 86.803 356.641 90.955c-20.46 4.136-32.755 28.758-32.755 28.758s20.887 17.918 41.347 13.782z",
    fill: "url(#c)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.239,
    cy: 274.353,
    rx: 23.281,
    ry: 22.268,
    transform: "rotate(180 702.239 274.353)",
    fill: "#666AF6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 412.707,
    cy: 489.617,
    r: 13.761,
    transform: "rotate(180 412.707 489.617)",
    fill: "#666AF6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 11.134,
    transform: "matrix(-1 0 0 1 255.453 199.809)",
    fill: "#666AF6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 18.041,
    ry: 17.347,
    transform: "matrix(-1 0 0 1 560.583 501.58)",
    fill: "#E1E4E5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 11.863,
    transform: "matrix(-1 0 0 1 268.409 311.814)",
    fill: "#E1E4E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.408,
    ry: 11.102,
    transform: "matrix(-1 0 0 1 643.67 453.608)",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 10.122,
    transform: "matrix(-1 0 0 1 497.652 91.514)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 9.891,
    transform: "scale(1 -1) rotate(-75 -167.047 -426.138)",
    fill: "#E1E4E5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 20.586,
    transform: "scale(1 -1) rotate(-75 231.188 -457.461)",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 605.534,
    y1: 432.836,
    x2: 845.808,
    y2: 319.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 100.554,
    y1: 432.836,
    x2: 340.827,
    y2: 319.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 439.7,
    y1: 112.33,
    x2: 243.06,
    y2: 110.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.829b8ecb240eb5a30f8b9310f9de9754.svg";
export { ForwardRef as ReactComponent };